<div id="{{id}}" class="{{#if hideCriteriaFirstTime}}hidden{{/if}}">
  <field-item item="criteriaFormModel">
    <field-hcombo id="criteria-selectByType" name="type" label="" {options}="typeOptions"></field-hcombo>
      <uda-list of="ersTrip" name="ersTrip" label-key="ersTrip" class="inlineGroup" {visible}="states.ersTrip"></uda-list>
  </field-item>
</div>
